var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reports_section_summary",class:_vm.isFullScreenMode?'reports_section_full_screen':''},[(_vm.getUserSelected === null)?_c('history-logs'):_c('user-detail')],1)}
var staticRenderFns = []

export { render, staticRenderFns }